import React from 'react';
import { Calendar, Leaf, Thermometer, Star } from 'lucide-react';
import { CONSTANTS } from '../../data';

interface StatusIconsProps {
  dailyBlend: any;
  seededSession: boolean;
  activeSeason: any;
  legendaryUnlocks: any;
  isMobile: boolean;
}

const StatusIcons: React.FC<StatusIconsProps> = ({
  dailyBlend,
  seededSession,
  activeSeason,
  legendaryUnlocks,
  isMobile,
}) => {
  return (
    <>
      {dailyBlend.completed && !seededSession && (
        <div className="bg-blue-600 px-1.5 sm:px-2 py-0.5 sm:py-1 rounded flex items-center gap-0.5 sm:gap-1 text-xs">
          <Calendar size={isMobile ? 12 : 16} />
          {!isMobile && <span className="text-xs sm:text-sm hidden md:inline">Daily</span>}
        </div>
      )}
      {activeSeason && (
        <div
          className={`${
            CONSTANTS.ROTATING_SEASONS.DEFINITIONS[activeSeason.type].ui_color
          } px-1.5 sm:px-2 py-0.5 sm:py-1 rounded flex items-center gap-0.5 sm:gap-1 text-xs`}
          title={`Season: ${activeSeason.name}`}
        >
          <Leaf size={isMobile ? 12 : 16} />
          {!isMobile && <span className="text-xs sm:text-sm hidden md:inline">Season</span>}
        </div>
      )}
      {legendaryUnlocks.temperatureControl && (
        <div
          className="bg-red-600 px-1.5 sm:px-2 py-0.5 sm:py-1 rounded flex items-center gap-0.5 sm:gap-1 text-xs"
          title="Temperature Control Unlocked"
        >
          <Thermometer size={isMobile ? 12 : 16} />
        </div>
      )}
      {legendaryUnlocks.qualityGrades && (
        <div
          className="bg-yellow-600 px-1.5 sm:px-2 py-0.5 sm:py-1 rounded flex items-center gap-0.5 sm:gap-1 text-xs"
          title="Quality Grades Unlocked"
        >
          <Star size={isMobile ? 12 : 16} />
        </div>
      )}
    </>
  );
};

export default StatusIcons;
